export const variants = {
  primary: {
    active: {
      background: 'hero.plum',
      border: 'hero.plum',
      text: 'text.lightest',
    },
  },
  secondary: {
    active: {
      background: 'background.lightest',
      border: 'background.lightest',
      text: 'hero.plum',
    },
  },
  yellow: {
    active: {
      background: 'secondary.yellow',
      border: 'secondary.yellow',
      text: 'hero.plum',
    },
  },
  lilac: {
    active: {
      background: 'hero.lilac',
      border: 'hero.lilac',
      text: 'hero.plum',
    },
  },
  cancel: {
    active: {
      background: 'text.lightest',
      border: 'hero.red',
      text: 'status.errorPrimary',
    },
  },
  /*To Do: Cleanup after Brand Launch*/
  dark: {
    active: {
      background: 'hero.plum',
      border: 'hero.plum',
      text: 'text.lightest',
    },
  },
  carrot: {
    active: {
      background: 'hero.lilac',
      border: 'hero.lilac',
      text: 'hero.plum',
    },
  },
  chia: {
    active: {
      background: 'hero.plum',
      border: 'hero.plum',
      text: 'text.lightest',
    },
  },
  cranberry: {
    active: {
      background: 'secondary.yellow',
      border: 'secondary.yellow',
      text: 'hero.plum',
    },
  },
  blueberry: {
    active: {
      background: 'hero.plum',
      border: 'hero.plum',
      text: 'text.lightest',
    },
  },
  egg: {
    active: {
      background: 'secondary.yellow',
      border: 'secondary.yellow',
      text: 'text.primary',
    },
  },
  sweetPotato: {
    active: {
      background: 'hero.lilac',
      border: 'hero.lilac',
      text: 'hero.plum',
    },
  },
  kale: {
    active: {
      background: 'hero.plum',
      border: 'hero.plum',
      text: 'text.lightest',
    },
  },
  yam: {
    active: {
      background: 'hero.plum',
      border: 'hero.plum',
      text: 'text.lightest',
    },
  },
  spinach: {
    active: {
      background: 'hero.lilac',
      border: 'hero.lilac',
      text: 'text.primary',
    },
  },
  watermelon: {
    active: {
      background: 'hero.plum',
      border: 'hero.plum',
      text: 'text.lightest',
    },
  },
  sea: {
    active: {
      background: 'hero.plum',
      border: 'hero.plum',
      text: 'text.lightest',
    },
  },
};
